import styled from 'styled-components';

export const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  &[data-with-sidebar*='true'] {
    @media (max-width: 1000px) {
      padding-left: 50px;
    }

    @media (min-width: 1000px) {
      padding-left: 17rem;
    }
  }
`;
